import { FC } from 'react';

import { FeaturedAll } from '@bpm-web-app/components/pages';
import { DownloadPageLayout } from '@bpm-web-app/components';

const AllFeaturedPage: FC<{ title: string }> = ({ title }) => (
    <DownloadPageLayout title={title}>
        <FeaturedAll />
    </DownloadPageLayout>
);

export default AllFeaturedPage;

export async function getStaticProps() {
    return {
        props: {
            title: 'New Music',
        },
    };
}
